import { serviceHost } from "../../common/const";
import ServiceRequest from "../../utils/service-request";

export const searchClient = async (client) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/clientSearch",
      client
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const updateClient = async (clientId, action) => {
  try {
    let data = { clientId, action };
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/clientSearch/update",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const getClientNames = async (value) => {
  try {
    let data = { value };
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/clientSearch/getClientNames",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};
